<template>
  <div>
    <h6 class="tag-listing-filters-group-name">{{ group.tagGroupName }}</h6>
    <div
      class="tag-listing-filters-tag-entries"
      :class="getTagEntriesClassName"
      :style="tagEntriesStyle"
    >
      <EntryFilter
        v-for="(tagEntry, index) in entries"
        :key="tagEntry.id"
        :entry="tagEntry"
        :group="group"
        class="tag-listing-filters-tag-entry"
        v-show="isExpanded || index < 6"
      >
      </EntryFilter>
    </div>
    <div v-if="entries.length > 6" class="view-more" @click="toggleView">
      {{ isExpanded ? t('listing.view.less') : t('listing.view.more') }}
    </div>
  </div>
</template>

<script>
import EntryFilter from './EntryFilter'

export default {
  name: 'GroupFilter',
  components: {
    EntryFilter
  },
  props: {
    group: {
      type: Object,
      required: true
    },
    entries: {
      type: Array,
      required: true
    },
    isBaseGroup: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      isExpanded: false
    }
  },
  computed: {
    getTagEntriesClassName() {
      let className = ''
      className += this.group.tagDisplayType
      return className
    },
    tagEntriesStyle() {
      return this.entries.length > 6 && !this.isExpanded ? {maxHeight: '7rem', overflow: 'hidden'} : {}
    }
  },
  methods: {
    toggleView() {
      this.isExpanded = !this.isExpanded
    }
  }
}
</script>

<style scoped>
.tag-listing-filters-tag-entries {
  /* Other styles if any */
}

.view-more {
  cursor: pointer;
  text-align: left;
  margin-top: 0.5rem;
  color:#1A8FE3;
  font-size: 11px;
}
</style>
